/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_DiffInputs */

const en_cargos_diff = /** @type {(inputs: Cargos_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diff`)
};

const es_cargos_diff = /** @type {(inputs: Cargos_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dif`)
};

/**
* | output |
* | --- |
* | "Diff" |
*
* @param {Cargos_DiffInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_diff = /** @type {((inputs?: Cargos_DiffInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_DiffInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_diff(inputs)
	return es_cargos_diff(inputs)
});